<template>
  <v-col cols="12">
    <v-col class="col-md-offset-1 col-md-10 col-sm-12 col-xs-12">
      <v-card color="white" dark class="rounded-xl">
        <v-card-title class="text-h5" style="color: #6b6868">
          <v-icon style="padding-right: 0.3em; color: #6b6868"
            >mdi-lock-minus-outline</v-icon
          >
          Mot de passe
        </v-card-title>

        <v-card-subtitle>
          <v-alert
            outlined
            type="success"
            prominent
            border="left"
            text
            style="margin-top: 1em"
            v-if="userInfosIsUpdated === true"
          >
            Votre mot de passe a bien été mis à jour.
          </v-alert>
          <v-alert
            outlined
            type="error"
            prominent
            border="left"
            style="margin-top: 1em"
            v-if="formErrors.length > 0"
          >
            <b>Veuillez corriger les erreurs suivantes:</b>
            <ul>
              <li v-for="(error, index) in formErrors" :key="index">
                • {{ error }}
              </li>
            </ul>
          </v-alert>
          <section
            style="
              background: rgba(255, 255, 255, 0.9);
              color: #777171;
              padding: 1em;
            "
          >
            <v-form>
              <v-row>
                <v-col cols="12"> </v-col>

                <v-col cols="12" style="margin-top: -2em">
                  <v-text-field
                    v-model="formFields.newPassword"
                    prepend-inner-icon="mdi-lock-minus-outline"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required]"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Nouveau mot de passe"
                    light
                    hint="At least 8 characters"
                    counter
                    @click:append="show1 = !show1"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" style="margin-top: -2em">
                  <v-text-field
                    v-model="formFields.newPasswordAgain"
                    prepend-inner-icon="mdi-lock-minus-outline"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required]"
                    :type="show2 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Ressaisir le nouveau mot de passe"
                    light
                    hint="At least 8 characters"
                    counter
                    @click:append="show2 = !show2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" style="margin-top: -2em">
                  <v-text-field
                    v-model="formFields.oldPassword"
                    prepend-inner-icon="mdi-lock-minus-outline"
                    :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required]"
                    :type="show3 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Ancien mot de passe pour confirmer votre opération"
                    light
                    hint="At least 8 characters"
                    counter
                    @click:append="show3 = !show3"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" offset-md="4" md="4">
                  <v-btn
                    color="success"
                    rounded
                    class="col-12"
                    v-on:click="updatePassword"
                  >
                    <v-icon left> mdi-content-save-all-outline </v-icon>
                    Mettre à jour
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </section>
        </v-card-subtitle>
      </v-card>
    </v-col>
  </v-col>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";

export default Vue.extend({
  name: "UpdatePasswordForm",
  data: function () {
    return {
      userInfosIsUpdated: false,
      formFields: {
        newPassword: null,
        newPasswordAgain: null,
        oldPassword: null,
      },
      rules: {
        required: (value) => !!value || "Required.",
        //min: v => v.length >= 8 || 'Min 8 characters',
      },
      currentUserInfos: {},
      menu: false,
      show1: false,
      show2: false,
      show3: false,
      formErrors: [],
    };
  },
  methods: {
    checkForm: function () {
      this.formErrors = [];
      let isValid = true;

      if (
        !this.formFields.newPassword ||
        this.formFields.newPassword.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push("Le nouveau mot de passe est obligatoire.");
      }

      if (
        !this.formFields.newPasswordAgain ||
        this.formFields.newPasswordAgain.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push("Veuillez ressaisir le nouveau mot de passe");
      }

      if (this.formFields.newPasswordAgain !== this.formFields.newPassword) {
        isValid = false;
        this.formErrors.push("Les 2 mots de passes ne correspondent pas.");
      }

      if (
        !this.formFields.oldPassword ||
        this.formFields.oldPassword.trim() === ""
      ) {
        isValid = false;
        this.formErrors.push(
          "Veuillez saisir votre mot de passe actuel pour confirmer l'opération."
        );
      }

      return isValid;
    },
    updatePassword: function () {
      if (this.checkForm()) {
        const httpClient = new HttpClient();
        httpClient
          .updateUserPassword(
            {
              password: this.formFields.oldPassword,
              newPassword: this.formFields.newPassword,
            },
            localStorage.getItem("jwt-token")
          )
          .then((value) => {
            localStorage.setItem("currentUser", JSON.stringify(value.data));
            this.userInfosIsUpdated = true;
            setTimeout(
              function () {
                this.userInfosIsUpdated = false;
              }.bind(this),
              4000
            );
          })
          .catch((reason) => {
            if (reason.response.status === 401) {
              this.$router.push("/logout");
            } else if (reason.response.status === 403) {
              this.formErrors = [];
              this.formErrors.push(
                "Votre ancien mot de passe est invalide. Impossible de confirmer votre identité"
              );
            } else {
              this.formErrors = [];
              this.formErrors.push("Une erreur s'est produite");
            }
          });
      }
    },
  },
});
</script>

<style scoped></style>
